import React from 'react';

import {useEvent} from 'effector-react';
import {useTranslation} from 'react-i18next';
import {generatePath, useHistory} from 'react-router-dom';

import {PermissionAccess} from 'components/common/PermissionAccess';
import {DropdownMenu} from 'components/ui-kit/DropdownMenu';
import {Modal} from 'components/ui-kit/Modal';
import {ROUTE} from 'core/routes';
import {utilisationGroupChanged} from 'models/documents/create';
import {fetchInvoiceIrnFx} from 'models/documents/invoices/create';
import {UserPermission, UserRoles} from 'types';

import {AffixingTypeButton, AffixingTypesWrapper, ControlsWrapper} from './styled';

export const Controls = () => {
    const {t} = useTranslation();
    const history = useHistory();
    const fetchIrn = useEvent(fetchInvoiceIrnFx);

    const [showAffixingTypeModal, setShowAffixingTypeModal] = React.useState(false);
    const ModalSelectAffixingType = () => {
        const translate = (key: string) => t('pages.documents.utilisationTypeSelect.' + key);

        const onSelect = (group: boolean) => {
            utilisationGroupChanged(group);
            history.push(`${ROUTE.DOCUMENTS_CREATE_UTILISATION}?group=${group}`);
        };

        return (
            <Modal
                title={translate('question')}
                show={showAffixingTypeModal}
                modalWidth={1}
                onClose={() => setShowAffixingTypeModal(false)}
            >
                <AffixingTypesWrapper>
                    <AffixingTypeButton onClick={() => onSelect(false)}>
                        <img src="/icons/affixing/unitType.webp" alt="" />
                        {translate('unit')}
                    </AffixingTypeButton>
                    <AffixingTypeButton onClick={() => onSelect(true)}>
                        <img src={'/icons/affixing/groupType.webp'} alt="" />
                        {translate('group')}
                    </AffixingTypeButton>
                </AffixingTypesWrapper>
            </Modal>
        );
    };

    return (
        <ControlsWrapper>
            <DropdownMenu label={t('pages.documents.documents.create')} width={195}>
                <DropdownMenu.List>
                    <PermissionAccess
                        permissions={[UserPermission.DOCUMENT_CREATE_DROPOUT]}
                        roleAccess={[UserRoles.ROLE_MPL_OPERATOR_ADMIN]}
                    >
                        <DropdownMenu.Item
                            onSelect={() => {
                                history.push(ROUTE.DOCUMENTS_CREATE_DROP_OUT);
                            }}
                        >
                            {t('pages.documents.details.DropOut.DropOutId')}
                        </DropdownMenu.Item>
                    </PermissionAccess>
                    <PermissionAccess permissions={[UserPermission.DOCUMENT_CREATE_AGGREGATION]}>
                        <DropdownMenu.Item
                            onSelect={() => {
                                history.push(ROUTE.DOCUMENTS_CREATE_AGGREGATION);
                            }}
                        >
                            {t('pages.documents.details.Aggregation.AggregationId')}
                        </DropdownMenu.Item>
                    </PermissionAccess>
                    <PermissionAccess permissions={[UserPermission.DOCUMENT_CREATE_COMMISSIONING]}>
                        <DropdownMenu.Item
                            onSelect={() => {
                                history.push(ROUTE.DOCUMENTS_CREATE_COMMISSIONING);
                            }}
                        >
                            {t('pages.documents.details.Introduce.IntroduceId')}
                        </DropdownMenu.Item>
                    </PermissionAccess>
                    <PermissionAccess permissions={[UserPermission.DOCUMENT_CREATE_UTILISATION]}>
                        <DropdownMenu.Item onSelect={() => setShowAffixingTypeModal(true)}>
                            {t('pages.documents.details.Utilization.UtilizationId')}
                        </DropdownMenu.Item>
                    </PermissionAccess>
                    <PermissionAccess permissions={[UserPermission.DOCUMENT_CREATE_DROPOUT]}>
                        <DropdownMenu.Item
                            onSelect={async () => {
                                try {
                                    const getInvoiceId = await fetchIrn();
                                    const setPath = generatePath(
                                        ROUTE.DOCUMENTS_CREATE_INVOICE_ID,
                                        {
                                            invoiceId: getInvoiceId.data,
                                        },
                                    );
                                    history.push(setPath, {from: location.pathname});
                                } catch (error) {
                                    console.log(((error as unknown) as {message: string}).message);
                                }
                            }}
                        >
                            {t('pages.documents.details.UPD.UPDId')}
                        </DropdownMenu.Item>
                    </PermissionAccess>
                    <PermissionAccess permissions={[UserPermission.DOCUMENTS_DECLARATION_CREATE]}>
                        <DropdownMenu.Item
                            onSelect={() => {
                                history.push(ROUTE.DOCUMENTS_GDS_CREATE);
                            }}
                        >
                            {t('pages.documents.gds.create')}
                        </DropdownMenu.Item>
                    </PermissionAccess>
                </DropdownMenu.List>
            </DropdownMenu>
            <ModalSelectAffixingType />
        </ControlsWrapper>
    );
};
